import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { LayoutGrid, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ToolbarButton } from "./ToolbarButton";
export function AutoLayoutButton({ onClick }) {
    const { t } = useTranslation();
    const [isRunning, setIsRunning] = useState(false);
    const handleClick = async ()=>{
        setIsRunning(true);
        try {
            // The bundled ELK blocks the main thread in a setTimeout(0) task that
            // can run before the spinner paints; yield one frame first.
            await new Promise((resolve)=>requestAnimationFrame(()=>setTimeout(resolve)));
            await onClick();
        } finally{
            setIsRunning(false);
        }
    };
    return /*#__PURE__*/ _jsx(ToolbarButton, {
        onClick: ()=>void handleClick(),
        disabled: isRunning,
        tooltip: t("flowKit.toolbar.autoLayout"),
        children: isRunning ? /*#__PURE__*/ _jsx(Loader2, {
            className: "h-4 w-4 animate-spin"
        }) : /*#__PURE__*/ _jsx(LayoutGrid, {
            className: "h-4 w-4"
        })
    });
}

//# sourceMappingURL=AutoLayoutButton.js.map